import styled, { keyframes } from "styled-components";

import signInBackground from "../../assets/wave2.svg";

export const Container = styled.div`
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  background: url(${signInBackground}) no-repeat center;
  background-size: cover;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 600px;
  background-color: #fff;
  border-radius: 20px;
  padding: 20px 0;
  -webkit-box-shadow: 5px 5px 50px 15px rgba(0, 0, 0, 0.2);
  box-shadow: 5px 5px 50px 15px rgba(0, 0, 0, 0.2);
`;

const appearFromLeft = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: ${appearFromLeft} 0.7s;

  img {
    height: 170px;
  }

  form {
    margin: 0 0 20px 0;
    width: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;

    h1 {
      color: var(--dark-grey);
      margin-bottom: 20px;
    }
  }

  a {
    color: var(--dark-grey-70);
    font-size: 14px;
    margin-top: 24px;
    transition: color 0.2s;

    &:hover {
      color: var(--dark-grey);
    }

    svg {
      margin-right: 8px;
    }
  }
`;
